import * as React from "react";
import Masonry from "react-masonry-css";
import Box from "@mui/material/Box";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import "./style.css";
import ImageFadeIn from "../../components/ImageFadeIn";
import { CustomTooltip } from "../../components/Tooltip";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { white } from "@mui/material/colors";
import ElementFadeIn from "../ElementFadeIn";

const CustomMasonry = (props) => {
    const { page, photos, enableFavourite } = props;
    const [displayImages, setDisplayImages] = useState(false);
    const [displayModalContent, setDisplayModalContent] = useState(false);
    const [displayHeart, setDisplayHeart] = useState(false);

    const [imageClicked, setImageClicked] = useState({});

    const isDesktop = useMediaQuery({ minWidth: 1180 });
    const md = useMediaQuery({ minWidth: 900 });
    const sm = useMediaQuery({ maxWidth: 767 });

    React.useEffect(() => {
        setDisplayImages(true);
        setTimeout(() => {
            setDisplayHeart(true);
        }, 500);
    }, []);

    const handleImageDetails = (index, item) => {
        let record = { ...imageClicked };
        record[item.id] = item.hasFavorites ? false : true;
        setImageClicked(record);
        if (enableFavourite) {
            if (record[item.id]) {
                props.selectedImage(item);
            }
        } else {
            props.selectedImage(item);
        }

        setDisplayModalContent(true);
    };

    const handleDelete = (event, item) => {
        event.stopPropagation();
        event.preventDefault();
        let record = { ...imageClicked };
        delete record[item.id];
        setImageClicked(record);
        if (item.hasFavorites) {
            props.onDelete(item);
        }
    };

    const breakpointColumnsObj = {
        default: 3,
        1100: 3,
        700: 2,
        500: 1,
    };

    return (
        <Box
            sx={{
                top: 0,
                left: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
            }}
            className={`fade-in-3 ${displayImages ? "show" : ""}`}>
            <Masonry
                style={{ marginTop: "18px", opacity: displayImages ? 1 : 0 }}
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column">
                {photos?.map((item, index) => (
                    <ElementFadeIn>
                        <div className="menu-item-hover " key={item.id}>
                            <CustomTooltip
                                page={page}
                                label={
                                    page === "Student" ? (
                                        <>
                                            <p className="artist-name">{item?.name}</p>
                                            <p noWrap={true} className="text">
                                                {item?.grade && <>Grade {item?.grade}</>}
                                                {item?.grade && item?.licenseYear && <>, </>}
                                                {item?.licenseYear && <>Year {item?.licenseYear}</>}
                                            </p>
                                        </>
                                    ) : page === "Corporate" ? (
                                        <>
                                            {item?.companyName && (
                                                <p className="artist-name" noWrap={true}>
                                                    {item?.companyName}
                                                </p>
                                            )}
                                        </>
                                    ) : (
                                        <></>
                                    )
                                }></CustomTooltip>
                            {enableFavourite && imageClicked[item.id] && (
                                <Box className="instagram-heart-container">
                                    <Box className="instagram-heart-click">
                                        <FavoriteIcon sx={{ color: "#c21b1b", width: "100%", height: "100%" }} />
                                    </Box>
                                </Box>
                            )}

                            {item.hasFavorites && enableFavourite && displayHeart && (
                                <Box
                                    className="instagram-heart-container"
                                    onClick={(event) => handleDelete(event, item)}>
                                    <Box className="instagram-heart">
                                        <FavoriteIcon sx={{ color: "#c21b1b", width: "100%", height: "100%" }} />
                                    </Box>
                                </Box>
                            )}

                            <ImageFadeIn
                                srcSet={`${item.img}?w=162&auto=format&dpr=2 2x`}
                                src={`${item.img}?w=162&auto=format`}
                                alt={item.title}
                                loading="lazy"
                                style={{
                                    display: "block",
                                    width: "100%",
                                }}
                                onClick={(event) => handleImageDetails(event, item)}></ImageFadeIn>
                        </div>
                    </ElementFadeIn>
                ))}
            </Masonry>
        </Box>
    );
};

export { CustomMasonry };
